import React from 'react';
import '../../styles/ticketTable.css';

const RMReportTable = ({reportData}) => {
    return (
        <div className="table-responsive ">
            <table className="table tickets_Messages_table">
                <thead>
                    <tr className="ticket_table_head">
                        <th scope="col">Type</th>
                        <th scope="col">Total Investments</th>
                        <th scope="col">Total Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Static data for table */}
                    <tr className="ticket_table">
                        <td>Lumpsum</td>
                        <td>{reportData?.type?.lumpsum}</td>
                        <td>₹{Number(reportData?.amount?.lumpsum || 0).toFixed(2)}</td>
                    </tr>
                    <tr className="ticket_table">
                        <td>SIP</td>
                        <td>{reportData?.type?.sip}</td>
                        <td>₹{Number(reportData?.amount?.sip || 0).toFixed(2)}</td>
                    </tr>
                    <tr className="ticket_table">
                        <td>STP</td>
                        <td>{reportData?.type?.stp}</td>
                        <td>₹{Number(reportData?.amount?.stp || 0).toFixed(2)}</td>
                    </tr>
                    <tr className="ticket_table">
                        <td>Switch</td>
                        <td>{reportData?.type?.switch}</td>
                        <td>₹{Number(reportData?.amount?.switch || 0).toFixed(2)}</td>
                    </tr>
                    <tr className="ticket_table">
                        <td>SWP</td>
                        <td>{reportData?.type?.swp}</td>
                        <td>₹{Number(reportData?.amount?.swp || 0).toFixed(2)}</td>
                    </tr>

                    {/* Total row */}
                    <tr className="ticket_table total_row">
                        <td>Total</td>
                        <td>{reportData?.total?.investments}</td>
                        <td>₹{Number(reportData?.total?.amount || 0).toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default RMReportTable;
